import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SHARED_MODULES } from '@app/shared';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './modal-video-player.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalVideoPlayerComponent {
  public readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  public readonly data = inject(DIALOG_DATA);
}
